import { render, staticRenderFns } from "./RTablePopup.vue?vue&type=template&id=16c95682&scoped=true&"
import script from "./RTablePopup.vue?vue&type=script&lang=js&"
export * from "./RTablePopup.vue?vue&type=script&lang=js&"
import style0 from "./RTablePopup.vue?vue&type=style&index=0&id=16c95682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c95682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
